// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"5f8894fa","700":"b154321f","788":"5c772d46"}[chunkId] + ".chunk.js";
};